import { JSONSchema6 } from "json-schema";

const createChargeSchema: JSONSchema6 =
{
    title: "Create Charge",
    description: "You can create a Charge to authorize payment, if you have a Charge Permission in a Chargeable state. You can optionally capture payment immediately by setting captureNow to true. You can create up to 25 Charges per one-time Charge Permission. The response for Create Charge will include a Charge ID. This is the only time this value will ever be returned, so you must store the ID in order to capture payment, Get Charge details, or Create Refund at a later date.",
    properties: {
        "header": {
            type: "object",
            properties: {
                "x-amz-pay-idempotency-key": {
                    type: "string"
                },
                "x-amz-pay-simulation-code": {
                    title: "x-amz-pay-simulation-code",
                    type: "string"
                }
           },
            required: ["x-amz-pay-idempotency-key"]
        },
        "payload": {
            type: "object",
            properties: {
                "chargePermissionId": {
                    type: "string"
                },
                "chargeAmount": {
                    type: "object",
                    properties: {
                        "amount": {
                            type: "string"
                        },
                        "currencyCode": {
                            type: "string",
                            enum: ["", "AUD", "GBP", "DKK", "EUR", "HKD", "JPY", "NZD", "NOK", "ZAR", "SEK", "CHF", "USD"]
                        }
                    },
                    required: ["amount", "currencyCode"]
                },
                "captureNow": {
                    type: "boolean"
                },
                "softDescriptor": {
                    type: "string"
                },
                "canHandlePendingAuthorization": {
                    type: "boolean"
                },
                "merchantMetadata": {
                    type: "object",
                    properties: {
                        "merchantReferenceId": {
                            type: "string",
                            maxLength: 256
                        },
                        "merchantStoreName": {
                            type: "string",
                            maxLength: 50
                        },
                        "noteToBuyer": {
                            type: "string",
                            maxLength: 255
                        },
                        "customInformation": {
                            type: "string",
                            maxLength: 4096
                        }
                    }
                },
                "providerMetadata": {
                    type: "string"
                },
                "channel": {
                    type: "string",
                    enum: [ "Web", "Phone", "App", "Alexa", "PointOfSale", "FireTv", "Offline"]
                },
                "chargeInitiator": {
                    type: "string",
                    enum: [ "CITU", "MITU", "CITR", "MITR"]
                }
            },
            required: ["chargePermissionId","chargeAmount"]
        }
    },
    required: ["header", "payload"]
}

export default createChargeSchema;
